import React from "react";



const indexIcon = (indexImage, indexProgress) => `./icono${indexImage <= indexProgress + 1 ? indexImage: indexImage +'gris'}.svg`;

const getImg = (width = 25, className,  indexProgress, indexImage) => (
    <img
    width={width}
    className={className}
    src={require(`${indexIcon(indexImage, indexProgress)}`).default}
    alt="imagen"
  />
);

export const Img1 = ({ width = 75, className }) => (
    <img
      width={width}
      className={className}
      src={require(`./icono1.svg`).default}
      alt="imagen"
    />
    
  );
  export const Img2 = ({ width = 75, className, indexProgress }) =>(
    getImg(width, className, indexProgress, 2)
  );
    
  export const Img3 = ({ width = 75, className, indexProgress }) =>
    getImg(width, className, indexProgress, 3);
  


export const IconFaceHappy = ({classNameIcon=''}) => ( 
    <img className={classNameIcon} src={require(`./icono4.svg`).default} alt="imagen" />
);

export const IconFaceSad = ({classNameIcon= ''}) => ( 
    <img className={classNameIcon} src={require(`./icono5.svg`).default} alt="imagen" />
);

export const IconCheck= ({width = 25}) => ( 
    <img width={width} src={require(`./icono6.svg`).default} alt="imagen" />
);

export const IconInfo= () => ( 
  <img className="icon-info" src={require(`./icono7.svg`).default} alt="imagen" />
);


export const IconNext = ({ width = 25 }) => (
    <img width={width} src={require(`./arrow-right.png`).default} alt="imagen" />
  );

export const ImgMotor =({ width = 25 }) =>  (
  <img width={width} src={require(`./Motor.webp`).default} alt="imagen" />
)

export const ImgPlaca =({ width = 25 }) =>  (
  <img width={width} src={require(`./Placa.webp`).default} alt="imagen" />
)

export const ImgChasis =({ width = 25 }) =>  (
  <img width={width} src={require(`./Chasis.webp`).default} alt="imagen" />
)

export const ImgColor =({ width = 25 }) =>  (
  <img width={width} src={require(`./Color.webp`).default} alt="imagen" />
)

export const IconVisaMastercard =({ width = 25 }) =>  (
  <img width={width} src={require(`./Groupgg.png`).default} alt="imagen" />
)